import styled, { css } from 'styled-components'

const LabelInput = styled.span`
  position: relative;

  color: ${props => props.color || '#707070 !important'};
  font-weight: 500;
  font-size: ${props => props.fontSize || '14px'};

  letter-spacing: 0.01em;
  padding: ${props => props.padding || ''};
  width: ${props => props.width || ''};
  top: ${props => props.top || ''};
  ${props =>
    props.isImportant &&
    css`
      font-size: 15px;
      font-weight: 500;
      color: #4d566e;
      
    `}
  ${props => props.labelStyle || ''}
  ${props =>
    props.required &&
    `&::after {
      content: '';
      border-radius: 50%;
      height: 4px;s
      width: 4px;
      position: absolute;
      top: 8px;
      margin-left:5px;
      padding-left:2px;
  }`}
  span {
    font-weight: 400;
  }
`
export default LabelInput
